export default __webpack_public_path__ + "static/media/device-floppy.a5337c1e.svg";